type ProgressBarProps = {
  progressPercentage: number
}

export const ProgressBar = ({
  progressPercentage,
}: ProgressBarProps): JSX.Element => (
  <div className='h-2.5 w-11/12 bg-stone-300'>
    <div
      style={{ width: `${progressPercentage}%` }}
      className='h-full bg-brand-purple'
    ></div>
  </div>
)
